import {Injectable, Optional} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {Locale} from "../enum/locale";

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  localeChanged$ = new BehaviorSubject<string>(this.initialLocale);

  constructor(@Optional() private translateService: TranslateService) { }

  updateLocale(locale: Locale) {
    this.localeChanged$.next(locale);
    this.translateService.use(locale);
    localStorage.setItem('locale', locale);
  }

  get currentLocale() {
    return this.localeChanged$.value;
  }

  get initialLocale() {
    if (localStorage.getItem('locale')) {
      return localStorage.getItem('locale') as Locale;
    }

    // Determine based on browser language
    const browserLang = this.translateService.getBrowserLang();

    // If browser language (2 char) is in Locale enum, return it
    if (Object.values(Locale).includes(browserLang as Locale)) {
      return browserLang as Locale;
    }

    return Locale.EN;
  }
}
